window.dn = window.dn || {};

/** All methods related to billing */
(function (billing, $, undefined)
{
    var stripeLoaded = false;

    /**
     * Once a subscription or token processing function is called, this is where the Stripe object is stored.
     */
    billing.Processor = null;

    /**
     * If we've loaded this user's payment sources, they'll be stored here.
     */
    billing.PaymentSources = [];

    /**
     * If we've loaded this user's payment sources, they'll be stored here by PaymentSourceKey.
     */
    billing.PaymentSourcesByKey = {};

    /**
     * Start the process to apply a promo code. Explain the trial that will be starting.
     * 
     * @param (string)  code            - The promo code to apply.
     * @param (bool)    agreedToTrial   - Whether or not the user has explicitly agreed to start a trial. This only matters if the code is not "100% off forever" type of code.
     * @param (string)  token           - If we've determined the user needs to add a payment method to start the trial and apply the code, this needs to be set.
     */
    billing.ApplyCouponCode = function (code, agreedToTrial, token) 
    {
        if (!code) 
        {
            return;
        }

        dn.Spin(true);

        $.postJSON
        (
            "/api/v1/billing/coupon/" + code, 
            {
                AgreedToTrial: agreedToTrial, 
                Token: token,
                UserKey: dn.QueryString['userkey'], // in case of admin use on behalf of another user
                PlanId: ($(".dn-pricing-panel").filter(":visible").find('.btn-group-toggle .clickable').find('input[type="radio"][checked]').attr('id') || null)
            }
        )
        .done(function (response) 
        {
            dn.Spin(false);

            if (response.Success) 
            {
                return dn.ShowModal({
                    title: response.Title,
                    body: '<p class="lead">' + response.Message + '<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>',
                    onClose: function (e) 
                    {
                        if (response.NewUser) 
                        {
                            window.top.location.href = '/register/complete';
                        } 
                        else 
                        {
                            window.location.reload();
                        }
                    }
                });
            } 
            else 
            {
                var msg = '<p class="lead">We are unable to accept your code at this time.<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>';
                if (response.Message) {
                    msg = '<p class="lead">' + response.Message + '<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>';
                }

                return dn.ShowModal(
                {
                    title: response.Title,
                    body: msg
                });
            }
        }).
        fail(function (xhr, textStatus, errorThrown) 
        {
            dn.Spin(false);

            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
            {
                return dn.ShowModal(
                {
                    title: 'Unexpected Error',
                    body: 'An unexpected error occurred when applying your code.<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>'
                });
            }
        }); 
    };

    /**
     * Show a modal that explains the terms of the trial they're starting, which may prompt
     * for a credit card when they hit the "Start Trial" button, if the coupon requires one.
     */
    billing.ConfirmTrial = function(opt) 
    {
        var type = 'trial';
        var title = 'Start ' + opt.Coupon.DurationMonths + ' Month Trial';
        var provides = '<b>free trial</b> of';
        var reminder = 'We\'ll send a reminder email a week before your trial ends.';
        var buttonText = 'Start Trial';
        var stripeButtonText = 'Start Trial';

        if (opt.Coupon.PercentOff > 0 && opt.Coupon.PercentOff < 100)
        {
            title = opt.Coupon.PercentOff + '% Off' + (opt.Coupon.DurationMonths ? ' for ' + opt.Coupon.DurationMonths + ' Months' : '');
            provides = "<b>" + opt.Coupon.PercentOff + "% discount</b> off";
            type = 'discount';
            reminder = '';
            buttonText = 'Apply ' + opt.Coupon.PercentOff + '% Discount';
            stripeButtonText = 'Start Subscription';
        }
        else if (opt.Coupon.AmountOff > 0 && opt.Coupon.AmountOff < opt.SubscriptionPlan.Amount)
        {
            var amount = dn.DecimalToString(opt.Coupon.AmountOff / 100, 0);
            title = '$' + amount + ' Off' + (opt.Coupon.DurationMonths ? ' for ' + opt.Coupon.DurationMonths + ' Months' : '');
            provides = "<b>$" + amount + " discount</b> off";
            type = 'discount';
            reminder = '';
            buttonText = 'Apply $' + amount + ' Discount';
            stripeButtonText = 'Start Subscription';
        }

        return dn.ShowModal
        (
            {
                title: title,
                body: '<p class="lead">The code you entered provides a ' + provides + ' a <i>' + opt.SubscriptionPlan.Name + '</i> subscription ' + (opt.Coupon.DurationMonths ? 'for <b>' + opt.Coupon.DurationMonths + ' months</b>' : '<b>forever</b>') + '.</p>' + 
                (
                    (opt.HasDefaultPaymentMethod || opt.IsPaymentMethodRequired)
                        ? '<p>Once the ' + type + ' is over, your subscription will continue at the rate of ' + opt.SubscriptionPlan.AmountDisplayFull + ', unless canceled prior to the ' + type + ' ending. ' + reminder + ' If desired, you can cancel the subscription at any time on this page.</p>'
                        : '<p>Once the ' + type + ' is over, your subscription will end unless you choose to continue at the rate of ' + opt.SubscriptionPlan.AmountDisplayFull + ', by providing a payment method here on this page. We\'ll send a reminder email a week before your ' + type + ' ends.</p>'
                ), 
                buttonText: buttonText,
                hideCloseButton: true,
                onButtonClick: function() 
                {
                    if (opt.IsPaymentMethodRequired && !opt.HasDefaultPaymentMethod)
                    {
                        billing.Processor.open
                        (
                            {
                                name: dn.constants.CommunityName,
                                email: dn.user.Email,
                                panelLabel: stripeButtonText,
                                allowRememberMe: false,
                                locale: "auto",
                                token: function(ev, args) 
                                {
                                    // Now we have a token (ev.id) and can apply this code
                                    dn.billing.ApplyCouponCode(opt.CouponCode, true, ev.id);
                                }
                            }
                        );
                    }
                    else
                    {
                        // No payment method required here, just start it,
                        dn.billing.ApplyCouponCode(opt.CouponCode, true);
                    }
                }
            }
        );
    };

    /**
     * Lazy-loads Stripe V2 JavaScript. If called multiple times, only loads the JS once.
     * 
     * @param {func} onSuccess - If the JS could be loaded, this will be called.
     * @param {func} onFailure - If JS loading failed, this will be called with the usual ajax error responses (xhr, textStatus, errorThrown).
     */
    billing.LoadProcessor = function(onSuccess, onFailure)
    {
        if (stripeLoaded)
        {
            onSuccess();
        }
        else
        {
            $.getScript("https://checkout.stripe.com/checkout.js")
                .done(function () {
                    if (!billing.Processor)
                    {
                        billing.Processor = StripeCheckout.configure({
                            key: dn.constants.ApiKeyStripePublic,
                            image: dn.constants.UrlWebAssets + 'img/dnlogo-avatar-leaning-on-blue-900w.png',
                            locale: 'auto'
                        });
                    }
                    stripeLoaded = true;
                    onSuccess();
                })
                .fail(function (xhr, textStatus, errorThrown) {
                    onFailure(xhr, textStatus, errorThrown);
                }
            );
        }
    };

    /**
     * Handles processing subscription changes given a new payment token.
     * 
     * @param {object} data - Data from Stripe Checkout, such as the token id.
     * @param {object} args - Some arguments?
     * @param {bool} isApplePay - Whether or not this came from an Apple/Google Pay request.
     * @param {func} done - Callback when the function completes.
     * @param {func} fail - Callback when the function fails.
     */
    billing.UsePaymentSourceForSubscription = function(data, args, planId, isApplePay, done, fail) {

        var token;
        var dnStopReason; 

        if (data) {
            token = isApplePay ? data.token.id : data.id;
        } else {
            token = null; // used when no cc is required at registration
        }

        // DNStopReason cookie
        dnStopReason = Cookies.get('dnstop');

        $.postJSON("/api/v1/billing/subscription", {

            Token: token,
            PlanId: planId,
            DNStopReason: dnStopReason

        }).done(function(response) {

            if (done) { done(response); }

        }).fail(function(err) {

            if (isApplePay)
            {
                data.complete('fail');
            }

            if (fail) { fail(err); }
        });
    };

    /**
     * Downgrade a subscription.
     */
    billing.DowngradeSubscription = function(done, fail) 
    {
        $.deleteJSON("/api/v1/billing/subscription", {}).done(function(response) {

            if (done) { done(response); }

        }).fail(function(err) {

            if (fail) { fail(err); }
        });
    };

    /**
     * Undo cancellation of a subscription that is set to be canceled (i.e. downgraded to Free)
     */
    billing.StopDowngrade = function(done, fail) 
    {
        $.patchJSON("/api/v1/billing/subscription", {}).done(function(response) 
        {
            if (done) { done(response); }   
        }).fail(function(err) 
        {
            if (fail) { fail(err); }
        });
    };

    /**
     * Retrieve the user's payment sources on file.
     * 
     * @param (func) opt.onSuccess  - Callback function we'll pass the user's payment sources info to.
     * @param (func) opt.onFailure  - (Optional) callback function we'll pass any failure info to.
     */
    billing.GetPaymentSources = function(opt) 
    {
        $.get('/api/v1/billing/sources')
        .done(function(sources) 
        {
            billing.PaymentSources = sources;
            billing.PaymentSourcesByKey = billing.PaymentSources.reduce(function(map, obj) {
                map[obj.PaymentSourceKey] = obj;
                return map;
            }, {});
            opt.onSuccess(sources);
        })
        .fail(function(xhr, textStatus, errorThrown) 
        {
            if (opt.onFailure)
            {
                opt.onFailure(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * This retrieves the current user's payment sources, and renders them as a 
     * bootstrap dropdown into the provided jQuery element. If showSpinner is true, 
     * we'll put a spinner to reflect the loading status at the top level (i.e. where
     * the current selection is normally shown). 
     * 
     * When the user selects any of the payment sources, the selected source's PaymentSourceKey
     * value will be stored in data-payment-source-key attribute of the jQuery element
     * that was passed into this method. If known, the user's default payment source 
     * will be selected by default. If the user selects "New Credit Card", we will set
     * data-payment-source-key="card".
     * 
     * If opt.onSourceSelected is defined, we'll pass the selected payment source data
     * to the method. If opt.onAddSource is defined, we'll pass the type of source they
     * would like to add (at this point, only "card" is supported, to add a new card.)
     * 
     * If there's a failure retrieving the sources, the spinner stops spinning, and 
     * can be clicked to try to retrieve again.
     * 
     * If onSuccess callback is provided, we'll pass the sources to that function once
     * we've created the payment source dropdown.
     * 
     * Dropdown will be created as defined here: https://getbootstrap.com/docs/4.2/components/dropdowns/
     * 
     * @param {element} opt.element         - The element we want to put the dropdown in.
     * @param {bool} opt.showSpinner        - If true, show a spinner while waiting for update.
     * @param {func} opt.onSuccess          - (Optional) callback function we'll pass the wallet info to.
     * @param {func} opt.onFailure          - (Optional) callback function we'll pass any failure info to.
     * @param {func} opt.onSourceSelected   - (Optional) callback function we'll pass a selected payment source to.
     * @param {func} opt.onAddSource        - (Optional) callback function we'll call if the user wants to add a payment source.
     */
    billing.CreatePaymentSourceDropdown = function(opt) {

        var id = opt.element.attr('id');

        if (!id)
        {
            id = 'dn-payment-dropdown';
            opt.element.attr('id', id);
        }

        // Insert the blank dropdown, possibly with a spinner indicating we're loading sources
        opt.element.html('<button id="' + id + '-button" class="btn btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' + ((opt.showSpinner) ? '<i class="far fa-sync-alt fa-spin clickable"></i> Loading...' : '') + '</button>\
            <div class="dropdown-menu position-absolute" id="' + id + '-choices" aria-labelledby="' + id + '"></div>')
        .addClass('dropdown');

        billing.GetPaymentSources({

            onSuccess: function(sources) {

                // received payment sources, add them to the dropdown
                var defaultSource = null;

                $.each(sources, function(index, source) {
                    var choice = $('<button class="dropdown-item" id="' + source.PaymentSourceKey + '"><img src="' + source.BrandImage + '" class="payment-source" /> ' + source.Brand + ' ending in ' + source.IdentifierSuffix + '</button>');
                    choice.click(function(e) {
                        var paymentSourceKey = $(this).attr('id');
                        var source = billing.PaymentSourcesByKey[paymentSourceKey];
                        $('#' + id).data('payment-source-key', paymentSourceKey);
                        $('#' + id + '-button').html('<img src="' + source.BrandImage + '" class="payment-source" /> ' + source.Brand + ' ending in ' + source.IdentifierSuffix);
                        if (opt.onSourceSelected)
                        {
                            opt.onSourceSelected(source);
                        }
                    });
                    $('#' + id + '-choices').append(choice);

                    if (source.IsDefault)
                    {
                        defaultSource = source;
                    }
                });

                $('#' + id + '-choices').append($('<div class="dropdown-divider"></div>'));

                var newCard = $('<button class="dropdown-item" id="card"><img src="' + dn.constants.BillingSourceDefaultImage + '" class="payment-source" /> New Credit Card</button>');
                newCard.click(function(e) {
                    $('#' + id).data('payment-source-key', 'card');
                    $('#' + id + '-button').html('<img src="' + dn.constants.BillingSourceDefaultImage + '" class="payment-source" /> New Credit Card');
                    if (opt.onAddSource)
                    {
                        opt.onAddSource('card');
                    }
                });
                $('#' + id + '-choices').append(newCard);

                if (defaultSource)
                {
                    $('#' + id).data('payment-source-key', defaultSource.PaymentSourceKey);
                    $('#' + id + '-button').html('<img src="' + defaultSource.BrandImage + '" class="payment-source" /> ' + defaultSource.Brand + ' ending in ' + defaultSource.IdentifierSuffix);
                }
                else
                {
                    $('#' + id).data('payment-source-key', "card");
                    $('#' + id + '-button').html('<img src="' + dn.constants.BillingSourceDefaultImage + '" class="payment-source" /> New Credit Card');
                }

                if (opt.onSuccess)
                {
                    opt.onSuccess(sources);
                }
            }, 

            onFailure: function(xhr, textStatus, errorThrown) 
            {
                if (opt.showSpinner)
                {
                    // we started a spinner, so we need to clear it out
                    opt.element.find('svg').removeClass('fa-spin');
                    opt.element.unbind("click").click(function(e) 
                    {
                        opt.element.find('svg').addClass('fa-spin');
                        billing.CreatePaymentSourceDropdown(opt);
                    });
                }
                if (opt.onFailure)
                {
                    opt.onFailure(xhr, textStatus, errorThrown);
                }
            }
        });
    };


    /**
     * This retrieves the current user's withdrawal destinations, and renders them as a 
     * bootstrap dropdown into the provided jQuery element. If showSpinner is true, 
     * we'll put a spinner to reflect the loading status at the top level (i.e. where
     * the current selection is normally shown). 
     * 
     * When the user selects any of the withdrawal destinations, the selected source's PaymentSourceKey
     * value will be stored in data-withdrawal-destination-key attribute of the jQuery element
     * that was passed into this method. If known, the user's default withdrawal destination 
     * will be selected by default. If the user selects "New Credit Card", we will set
     * data-withdrawal-destination-key="card".
     * 
     * If opt.onSourceSelected is defined, we'll pass the selected withdrawal destination data
     * to the method. If opt.onAddSource is defined, we'll pass the type of source they
     * would like to add (at this point, only "card" is supported, to add a new card.)
     * 
     * If there's a failure retrieving the sources, the spinner stops spinning, and 
     * can be clicked to try to retrieve again.
     * 
     * If onSuccess callback is provided, we'll pass the sources to that function once
     * we've created the withdrawal destination dropdown.
     * 
     * Dropdown will be created as defined here: https://getbootstrap.com/docs/4.2/components/dropdowns/
     * 
     * @param {element} opt.element         - The element we want to put the dropdown in.
     * @param {bool} opt.showSpinner        - If true, show a spinner while waiting for update.
     * @param {func} opt.onSuccess          - (Optional) callback function we'll pass the wallet info to.
     * @param {func} opt.onFailure          - (Optional) callback function we'll pass any failure info to.
     * @param {func} opt.onSourceSelected   - (Optional) callback function we'll pass a selected withdrawal destination to.
     * @param {func} opt.onAddSource        - (Optional) callback function we'll call if the user wants to add a withdrawal destination.
     */
    billing.CreateWithdrawalDropdown = function(opt) {

        var id = opt.element.attr('id');

        if (!id)
        {
            id = 'dn-withdrawal-dropdown';
            opt.element.attr('id', id);
        }

        // Insert the blank dropdown, possibly with a spinner indicating we're loading sources
        opt.element.html('<button id="' + id + '-button" class="btn btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' + ((opt.showSpinner) ? '<i class="far fa-sync-alt fa-spin clickable"></i> Loading...' : '') + '</button>\
            <div class="dropdown-menu position-absolute" id="' + id + '-choices" aria-labelledby="' + id + '"></div>')
        .addClass('dropdown');

        billing.GetWithdrawalDestinations({

            onSuccess: function(sources) {

                // received withdrawal sources, add them to the dropdown
                var defaultSource = null;

                $.each(sources, function(index, source) {
                    var choice = $('<button class="dropdown-item" id="' + source.WithdrawalDestinationKey + '"><img src="' + source.BrandImage + '" class="withdrawal-source" /> ' + source.Brand + ' ending in ' + source.IdentifierSuffix + '</button>');
                    choice.click(function(e) {
                        var withdrawalSourceKey = $(this).attr('id');
                        var source = billing.WithdrawalDestinationsByKey[withdrawalSourceKey];
                        $('#' + id).data('withdrawal-source-key', withdrawalSourceKey);
                        $('#' + id + '-button').html('<img src="' + source.BrandImage + '" class="withdrawal-source" /> ' + source.Brand + ' ending in ' + source.IdentifierSuffix);
                        if (opt.onSourceSelected)
                        {
                            opt.onSourceSelected(source);
                        }
                    });
                    $('#' + id + '-choices').append(choice);

                    if (source.IsDefault)
                    {
                        defaultSource = source;
                    }
                });

                $('#' + id + '-choices').append($('<div class="dropdown-divider"></div>'));

                var newCard = $('<button class="dropdown-item" id="card"><img src="' + dn.constants.BillingSourceDefaultImage + '" class="withdrawal-source" /> New Credit Card</button>');
                newCard.click(function(e) {
                    $('#' + id).data('withdrawal-source-key', 'card');
                    $('#' + id + '-button').html('<img src="' + dn.constants.BillingSourceDefaultImage + '" class="withdrawal-source" /> New Credit Card');
                    if (opt.onAddSource)
                    {
                        opt.onAddSource('card');
                    }
                });
                $('#' + id + '-choices').append(newCard);

                if (defaultSource)
                {
                    $('#' + id).data('withdrawal-source-key', defaultSource.WithdrawalDestinationKey);
                    $('#' + id + '-button').html('<img src="' + defaultSource.BrandImage + '" class="withdrawal-source" /> ' + defaultSource.Brand + ' ending in ' + defaultSource.IdentifierSuffix);
                }
                else
                {
                    $('#' + id).data('withdrawal-source-key', "card");
                    $('#' + id + '-button').html('<img src="' + dn.constants.BillingSourceDefaultImage + '" class="withdrawal-source" /> New Credit Card');
                }

                if (opt.onSuccess)
                {
                    opt.onSuccess(sources);
                }
            }, 

            onFailure: function(xhr, textStatus, errorThrown) 
            {
                if (opt.showSpinner)
                {
                    // we started a spinner, so we need to clear it out
                    opt.element.find('svg').removeClass('fa-spin');
                    opt.element.unbind("click").click(function(e) 
                    {
                        opt.element.find('svg').addClass('fa-spin');
                        billing.CreateWithdrawalDropdown(opt);
                    });
                }
                if (opt.onFailure)
                {
                    opt.onFailure(xhr, textStatus, errorThrown);
                }
            }
        });
    };

    /** 
     * Return the given unix timestamp as a formatted date string: 
     * MMM D, YYYY and optional time if `showTime` is true. 
     * 
     * Examples:
     * 
     * billing.UnixTimestampToDate(1546300800) => "Jan 1, 2019"
     * billing.UnixTimestampToDate(1546300800, true) => "Jan 1, 2019 12:00:00 AM"
     */
    billing.UnixTimestampToDate = function(unixTimestamp, showTime)
    {
        return moment.unix(unixTimestamp).locale('en').format('MMM D, YYYY' + (showTime ? ' h:mm:ss A' : ''));
    };

    /**
     * Change from one subscription plan to another, e.g. go from free to premium or vice versa.
     * 
     * @param {string} planId - The new plan to switch to, e.g. null (for free) or "premium".
     * @param {func} done - Callback when the function completes.
     * @param {func} fail - Callback when the function fails.
     */
    billing.ChangePlan = function(planId, done, fail) {

        $.postJSON("/api/v1/billing/subscription", {

            Token: null,
            PlanId: planId

        }).done(function(response) {

            if (done) { done(response); }

        }).fail(function(err) {

            if (fail) { fail(err); }
        });
    };

    /**
     * Prompt the user with a Stripe option to set the payment method.
     */
    billing.SetPaymentMethod = function(event) 
    {
        billing.Processor.open({
            name: dn.constants.CommunityName,
            email: dn.user.Email,
            panelLabel: 'Update Payment Method',
            allowRememberMe: false,
            locale: "auto",
            token: function(ev, args) 
            {
                $('#change-error').hide();
                dn.Spin(true);

                dn.billing.UsePaymentSourceForSubscription
                (
                    ev, args, null, false, 
                    function(subscription)
                    {
                        return dn.ShowModal({
                            title: 'Thank You!',
                            body: '<p class="lead">Your card on file has been updated.' + (subscription ? (' Your next bill date is <b>' + billing.UnixTimestampToDate(subscription.current_period_end) + '</b>' + ($("#next-due").val() ? ' for <b>' + $("#next-due").val() + '</b>' : '') + '. Receipts will be sent via email.') : '') + '<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>', 
                            onClose: function(closeEvent)
                            {
                                window.location.reload();
                            },
                            buttonText: 'Go to ' + dn.constants.CommunityName + ' Homepage',
                            onButtonClick: function(event, $element, options) 
                            {
                                options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                window.top.location.href = "/";
                            }
                        });
                    }, 
                    function(xhr, textStatus, errorThrown)
                    {
                        dn.Spin(false);

                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                        {
                            $('#change-error').text((xhr != null && xhr['responseJSON'] && xhr['responseJSON']['']) ? xhr.responseJSON[""].join(" ") : (xhr != null && xhr['responseText']) ? xhr.responseText : xhr).show();
                        }
                    }
                );
            }
        });

        if (event)
        {
            event.preventDefault();
        }
    };

    /**
     * Setup the subscription-related buttons for the billing/pricing page.
     */
    billing.SetupSubscriptions = function(email, hasSubscription, subscriptionActive, subscriptionPastDue, subscriptionCancelled, subscriptionCancelAtPeriodEnd, offerTrial) {

        dn.billing.LoadProcessor(function() {

            $('.dn-subscribe').click(function (e) 
            {
                var $originalButton = $(this);

                if ($(this).data('show-pro-warning'))
                {
                    // This is a non-pro and they're trying to subscribe. We want to show them a warning
                    // so that we don't get someone subscribing that might not be able to benefit from it.
                    // If they click continue, we'll modify the button they clicked to drop the data-show-pro-warning
                    // attribute, and then click it again.
                    return dn.ShowModal
                    ({
                        title: 'PLEASE NOTE',
                        body: '<p class="lead">Our paid subscriptions provide features that may only be accessible to professionals working within the vehicle service industry.</p><p>You have not yet earned our Pro badge, which unlocks access to our core topics. Purchasing a subscription will <b>not</b> unlock access to these topics and discussions.</p>' + (dn.user.CanRead ? '<p>We recommend you <a href="/settings#pro">earn the Pro badge</a> prior to starting a paid subscription.</p>' : '<p>If you choose to proceed, you will need to earn the Pro badge before you can fully utilize the Premium features.</p>'),
                        buttonText: 'Start Paid Subscription',
                        onButtonClick: function(event) 
                        {
                            $originalButton.data('show-pro-warning', '');
                            $originalButton.click();
                        }
                    });
                }

                var planId = $(this).data('id');
                var planName = $(this).data('name');
                var amount = $(this).data('amount');
                var periodDisplay = $(this).data('period-display');
                var amount = $(this).data('amount');
                var amountSuffix = periodDisplay ? "/" + periodDisplay : "";
                var periodTracking = $(this).data('period-tracking');

                if (amount > 0 && (dn.constants.BillingCreditCardRequired || !offerTrial)) {
                    // Open Checkout for subscription
                    billing.Processor.open({
                        name: dn.constants.CommunityName,
                        email: email,
                        description: 'Membership – ' + planName,
                        panelLabel: 'Subscribe for {{amount}}' + amountSuffix,
                        allowRememberMe: false,
                        locale: "auto",
                        amount: amount,
                        token: function (ev, args) 
                        {
                            $('#change-error').hide();
                            dn.Spin(true);
                            dn.billing.UsePaymentSourceForSubscription(ev, args, planId, false, function (result) 
                            {
                                if ($('#dn-subscription-data').hasClass('dn-new-user')) 
                                {
                                    dn.TrackCompletedRegistration(periodTracking, (amount / 100.0), result.id);
                                    billing.ShowThankYou
                                    (
                                        result, 
                                        function (event) 
                                        {
                                            window.top.location.href = '/register/complete';
                                        }, 
                                        null, 
                                        null
                                    );
                                }
                                else 
                                {
                                    billing.ShowThankYou
                                    (
                                        result, 
                                        function (event) 
                                        {
                                            window.location.reload();
                                        }, 
                                        'Go to ' + dn.constants.CommunityName + ' Homepage', 
                                        function (event, $element, options) 
                                        {
                                            options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                            window.top.location.href = "/"; 
                                        }
                                    );
                                }
                            },
                            function (xhr, textStatus, errorThrown) 
                            {
                                dn.Spin(false);

                                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                                {
                                    $('#change-error').text((xhr != null && xhr['responseJSON'] && xhr['responseJSON']['']) ? xhr.responseJSON[""].join(" ") : (xhr != null && xhr['responseText']) ? xhr.responseText : xhr).show();
                                }
                            });
                        }
                    });
                } 
                else 
                { 
                    // no cc required at registration
                    $('#change-error').hide();
                    dn.Spin(true);

                    dn.billing.UsePaymentSourceForSubscription(null, null, planId, false, 
                        function (result) 
                        {
                            if (!hasSubscription) 
                            {
                                dn.TrackCompletedRegistration(periodTracking, (amount / 100.0), result.id);

                                if (amount > 0)
                                {
                                    // Actual subscription created
                                    billing.ShowThankYou(result, function (event) {
                                        window.top.location.href = '/register/complete';
                                    }, null, null);
                                }
                                else
                                {
                                    // Free membership started, just redirect to register/complete
                                    window.top.location.href = '/register/complete';
                                }
                            }
                            else
                            {
                                billing.ShowThankYou
                                (
                                    result, 
                                    function (event) 
                                    {
                                        window.location.reload();
                                    }, 
                                    'Go to ' + dn.constants.CommunityName + ' Homepage', 
                                    function (event, $element, options) 
                                    {
                                        options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                        window.top.location.href = "/"; 
                                    }
                                );
                            }
                        },
                        function (xhr, textStatus, errorThrown) 
                        {
                            dn.Spin(false);

                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                $('#change-error').text((xhr != null && xhr['responseJSON'] && xhr['responseJSON']['']) ? xhr.responseJSON[""].join(" ") : (xhr != null && xhr['responseText']) ? xhr.responseText : xhr).show();
                            }
                        }
                    );
                }
                e.preventDefault();
            });

            // Switch to a different plan
            $('.dn-change-plan').click(function(e) {

                var planId = $(this).data('id');
                var planName = $(this).data('name');
                var amount = $(this).data('amount');
                var periodDisplay = $(this).data('period-display');
                var amount = $(this).data('amount');
                var amountSuffix = periodDisplay ? "/" + periodDisplay : "";
                var periodTracking = $(this).data('period-tracking');

                dn.Spin(true);
                dn.billing.ChangePlan(planId, function(subscription)
                {
                    return dn.ShowModal({
                        title: 'Thank You!', 
                        body: '<p class="lead">You have switched to the ' + planName + ' plan. ' + (amount > 0 ? 'Your next bill date is <b>' + billing.UnixTimestampToDate(subscription.current_period_end) + '</b>. Receipts will be sent via email.' : '') + '<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>', 
                        onClose: function(closeEvent)
                        {
                            window.location.reload();
                        },
                        buttonText: 'Go to ' + dn.constants.CommunityName + ' Homepage',
                        onButtonClick: function(event, $element, options) 
                        {
                            options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                            window.top.location.href = "/"; 
                        }
                    });
                }, 
                function(xhr, textStatus, errorThrown)
                {
                    dn.Spin(false);

                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                    {
                        $('#change-error').text((xhr != null && xhr['responseJSON'] && xhr['responseJSON']['']) ? xhr.responseJSON[""].join(" ") : (xhr != null && xhr['responseText']) ? xhr.responseText : xhr).show();
                    }
                });
                e.preventDefault();
            });

            // Open Checkout to update card on file
            $('.dn-update-paymentsource').click(billing.SetPaymentMethod);

            // They want to undo the downgrade
            $('#stop-downgrade').click(function (e) 
            {
                dn.Spin(true);

                billing.StopDowngrade(
                    function(subscription) 
                    {
                        if (subscription && !subscription.cancel_at_period_end && subscription.status != "canceled" && subscription.status != "incomplete_expired")
                        {
                            return dn.ShowModal(
                            {
                                title: 'Downgrade Stopped', 
                                body: '<p class="lead">Your subscription downgrade has been stopped. Thank you! Your next bill date is <b>' + billing.UnixTimestampToDate(subscription.current_period_end) + '</b>. Receipts will be sent via email.<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>', 
                                onClose: function(closeEvent)
                                {
                                    window.location.reload();
                                },
                                buttonText: 'Go to ' + dn.constants.CommunityName + ' Homepage',
                                onButtonClick: function(event, $element, options) 
                                {
                                    options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                    window.top.location.href = "/"; 
                                }
                            });
                        }
                        else
                        {
                            return dn.ShowModal({
                                title: 'Problem Stopping Downgrade', 
                                body: '<p class="lead">There was a problem encountered while trying to stop your upcoming subscription downgrade. Your subscription ' + ((subscription.status == 'canceled') ? 'was already downgraded' : 'is still set to be downgraded on <b>' + billing.UnixTimestampToDate(subscription.current_period_end) + '</b>') + '.<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>', 
                                onClose: function(closeEvent)
                                {
                                    window.location.reload();
                                },
                                buttonText: 'Go to ' + dn.constants.CommunityName + ' Homepage',
                                onButtonClick: function(event, $element, options) 
                                {
                                    options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                    window.top.location.href = "/"; 
                                }
                            });
                        }
                    }, 
                    function(xhr, textStatus, errorThrown) 
                    {
                        dn.Spin(false);

                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                        {
                            $('#change-error').text((xhr != null && xhr['responseJSON'] && xhr['responseJSON']['']) ? xhr.responseJSON[""].join(" ") : (xhr != null && xhr['responseText']) ? xhr.responseText : xhr).show();
                        }
                    }
                );
            });

            // They want to cancel their subscription (i.e. convert to Free)
            $('.downgrade-subscription').click(function(e) 
            {
                var planName = $(this).data('name');
                var isTrialing = $(this).data('is-trialing');
                var hasPaid = $(this).data('has-paid');

                var currentPeriodEnd = $('#dn-subscription-data').data('current-period-end');
                var currentPlanName = $('#dn-subscription-data').data('current-plan-name');

                return dn.ShowModal({
                    title: 'Confirm Downgrade to ' + planName, 
                    body: '<p class="lead">If you continue with your downgrade to the ' + planName + ' plan, your current ' + currentPlanName + ' plan benefits will end ' + ((isTrialing && hasPaid <= 0) ? '<b>immediately</b>' : 'on <b>' + currentPeriodEnd + '</b> at the end of your billing period') + '.</p><p>If you could provide us with feedback on why you are downgrading, we would <a href="/contact">love to hear it</a> so that we may improve our service.</p>', 
                    buttonText: 'Downgrade to ' + planName,
                    buttonClass: 'btn-danger',
                    onButtonClick: function(e)
                    {
                        dn.Spin(true);

                        billing.DowngradeSubscription
                        (
                            function(subscription) 
                            {
                                if (subscription['cancel_at_period_end'] || subscription['status'] == "incomplete_expired")
                                {
                                    return dn.ShowModal
                                    (
                                        {
                                            title: 'Downgrade Queued', 
                                            body: '<p class="lead">Your subscription has been set to downgrade to the ' + planName + ' plan on <b>' + billing.UnixTimestampToDate(subscription.current_period_end) + '</b>. You will be able to continue using all ' + currentPlanName + ' benefits until that time.</p><p>If you could provide us with feedback on why you are downgrading, we would <a href="/contact">love to hear it</a> so that we may improve our service.</p>', 
                                            onClose: function(closeEvent)
                                            {
                                                window.location.reload();
                                            },
                                            buttonText: 'Provide Feedback',
                                            onButtonClick: function(event, $element, options) 
                                            {
                                                options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                                window.top.location.href = "/contact" 
                                            }
                                        }
                                    );
                                }
                                else if (subscription['status'] == "canceled")
                                {
                                    return dn.ShowModal
                                    (
                                        {
                                            title: 'Subscription Downgraded', 
                                            body: '<p class="lead">Your subscription has been downgraded to the ' + planName + ' plan.</p><p>If you could provide us with feedback on why you downgraded, we would <a href="/contact">love to hear it</a> so that we may improve our service. Thank you!</p>', 
                                            onClose: function(closeEvent)
                                            {
                                                window.location.reload();
                                            },
                                            buttonText: 'Provide Feedback',
                                            onButtonClick: function(event, $element, options) 
                                            {
                                                options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                                window.top.location.href = "/contact" 
                                            }
                                        }
                                    );
                                }
                                else
                                {
                                    return dn.ShowModal({
                                        title: 'Problem Downgrading', 
                                        body: '<p class="lead">There was a problem encountered while trying to downgrade your subscription. Please <a href="/contact">contact us</a> so that we can help.</p>', 
                                        onClose: function(closeEvent)
                                        {
                                            window.location.reload();
                                        },
                                        buttonText: 'Contact Us',
                                        onButtonClick: function(event, $element, options) 
                                        {
                                            options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                            window.top.location.href = "/contact" 
                                        }
                                    }); 
                                }
                            },
                            function(xhr, textStatus, errorThrown) 
                            {
                                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                                {
                                    return dn.ShowModal(
                                    {
                                        title: 'Problem Downgrading', 
                                        body: '<p class="lead">There was a problem encountered while trying to downgrade your subscription. Please <a href="/contact">contact us</a> so that we can help.</p>', 
                                        onClose: function(closeEvent)
                                        {
                                            window.location.reload();
                                        },
                                        buttonText: 'Contact Us',
                                        onButtonClick: function(event, $element, options) 
                                        {
                                            options.onClose = null; // so that we don't trigger our onClose handler when the modal disappears
                                            window.top.location.href = "/contact" 
                                        }
                                    });
                                }
                            }
                        );
                    }
                });
            });
        }, 
        function(xhr, textStatus, errorThrown) 
        {
            dn.Spin(false);

            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
            {
                $('#change-error').text('There was a problem loading our payment processor (' + errorThrown + '). Please try again later.').show();
            }
        });
    };

    /**
     * Show a thank you message to the user for purchasing a subscription and/or starting a trial.
     * Any visible spinner will be hidden before showing the modal.
     * 
     * @param {object} subscription - The subscription object from Stripe.
     */
    billing.ShowThankYou = function(subscription, onClose, buttonText, onButtonClick)
    {
        return dn.ShowModal({
            title: 'Thank You!', 
            body: (subscription['trial_end']
                ? '<p class="lead">Your trial has been started. ' + (dn.constants.BillingCreditCardRequired ? "Your card will not be billed until your trial ends on" : "A credit card will be required on or before your trial end date") + ' <b>' + billing.UnixTimestampToDate(subscription.trial_end) + '</b>. Receipts will be sent via email. You can add or change your credit card on this page at any time.<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>'
                : '<p class="lead">Your subscription has been started. Your next bill date is <b>' + billing.UnixTimestampToDate(subscription.current_period_end) + '</b>. Receipts will be sent via email.<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.</p>'), 
            onClose: onClose,
            buttonText: buttonText,
            onButtonClick: onButtonClick
        });
    };

    // Close Checkout on page navigation:
    window.addEventListener('popstate', function() 
    {
        if (billing.Processor)
        {
            billing.Processor.close();
        }
    });

}(window.dn.billing = window.dn.billing || {}, jQuery));
